import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../state/state.tsx";
import { openModal } from "../../../../../state/ModalSlice/ModalSlice.ts";
import BankAccount2FADialog, { isBankAccount2FAVerified } from "../../../../Common/Components/BankAccount2FADialog";
import { selectUserSliceV2Data } from "../../../../../state/UserStatesV2/userSliceV2.ts";
import { UserStateV2 } from "../../../types/UserStateV2.ts";

export default function AddBankAccount() {
    const dispatch = useAppDispatch();
    const userData = useAppSelector(selectUserSliceV2Data) as UserStateV2 | null;
    const [show2FA, setShow2FA] = useState(false);

    const rawPhone = userData?.phone_number ?? "";
    const phoneNumber = rawPhone.startsWith("+91") ? rawPhone.slice(3) : rawPhone;

    function onClickAddBankAccount() {
        if (isBankAccount2FAVerified()) {
            dispatch(openModal("AddBankAccountOpen"));
        } else {
            setShow2FA(true);
        }
    }

    return (
        <>
            <div className={"grid sm:grid-cols-2 lg:grid-cols-3 px-4 mt-4  "}>
                <div
                    onClick={onClickAddBankAccount}
                    className={"col-span-3 bg-[#EEF2FD] rounded-lg flex justify-center items-center py-4 border-dashed border-[#1D4ED8] border-2 cursor-pointer"}
                >
                    <span>
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 5.7041V10.2831" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                            <path d="M9.79136 7.99414H5.20801" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M10.4286 1.75H4.57143C2.52976 1.75 1.25 3.19505 1.25 5.24072V10.7593C1.25 12.8049 2.52381 14.25 4.57143 14.25H10.4286C12.4762 14.25 13.75 12.8049 13.75 10.7593V5.24072C13.75 3.19505 12.4762 1.75 10.4286 1.75Z"
                                  stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </span>
                    <p className={"text-sm ml-1 text-[#1D4ED8]"}>Add Bank Account</p>
                </div>
            </div>

            <BankAccount2FADialog
                open={show2FA}
                phoneNumber={phoneNumber}
                onClose={() => setShow2FA(false)}
                onVerified={() => dispatch(openModal("AddBankAccountOpen"))}
            />
        </>
    );
}
